import React, { ReactElement } from 'react';
import cn from 'classnames';
import { Avatar } from '@odin-labs/components';
import jobsiteImage from 'images/jobsite.png';
import { JobsiteInvitation } from 'containers/selfOnboarding/types';
import { SelfOnboardingJobsiteWorker } from 'containers/selfOnboarding/steps/types';

export const classes = {
  jobsiteInfoHolder: cn(
    'odin-px-7.5 odin-flex odin-gap-x-4.5 odin-py-5 odin-bg-odin-highlight-gradient',
    'sm:odin-p-0 sm:odin-bg-none',
  ),
  jobsite: 'odin-text-sm odin-font-medium',
  contractor: 'odin-text-sm',
};

export type StepJobsiteInfoProps = {
  jobsiteInvitation: JobsiteInvitation;
  jobsiteWorker?: SelfOnboardingJobsiteWorker;
  contractorName?: React.ReactNode;
};

export function StepJobsiteInfo({
  jobsiteInvitation,
  jobsiteWorker,
  contractorName,
}: StepJobsiteInfoProps): ReactElement {
  const { name: jobsiteName, profilePicture } =
    jobsiteInvitation?.jobsiteContractor.jobsite ?? {};
  const contractorText =
    // Prefer the contractor from the worker's actual jobsite assignment: when an
    // already-assigned worker resumes onboarding, the invitation still points at
    // the default `Contractor Unassigned`, whereas the assignment holds the real one.
    jobsiteWorker?.jobsiteContractor.contractor.organization.name ??
    contractorName ??
    jobsiteInvitation?.jobsiteContractor.contractor.organization.name;

  return (
    <div className={classes.jobsiteInfoHolder}>
      <Avatar
        src={profilePicture?.downloadUrl ?? jobsiteImage}
        type="rounded"
      />
      <div>
        <div className={classes.jobsite}>{jobsiteName}</div>
        <div className={classes.contractor}>{contractorText}</div>
      </div>
    </div>
  );
}
